export interface IEbayMakeModelYearQuery {
  dvlaYearOfManufacture?: number | null;
  combinedMake?: string | null;
  modelRangeDescription?: string | null;
  categoryName?: string | null;
}

/** Builds the same eBay keyword query used on the unlisted table (year+make+model[+category]). */
export function ebayMakeModelYearCategoryQuery({
  dvlaYearOfManufacture,
  combinedMake,
  modelRangeDescription,
  categoryName,
}: IEbayMakeModelYearQuery): string {
  let string = "";

  if (dvlaYearOfManufacture) {
    string = `${dvlaYearOfManufacture}+`;
  }

  string += combinedMake ?? "";
  string += "+";
  string += modelRangeDescription ?? "";

  if (categoryName) {
    string += `+${categoryName}`;
  }

  return string;
}

export interface IEbayEngineSearchVehicle {
  combinedMake?: string | null;
  combinedModel?: string | null;
  engineModelCode?: string | null;
}

/** Keyword query for engine price research (matches booking pricing). */
export function ebayEngineSearchQuery(vehicle: IEbayEngineSearchVehicle): string {
  return `${vehicle.combinedMake ?? ""} ${vehicle.combinedModel ?? ""} ${vehicle.engineModelCode ?? ""} engine`.trim();
}

export function ebayEngineSearchUrl(vehicle: IEbayEngineSearchVehicle): string | null {
  if (!vehicle.engineModelCode?.trim()) {
    return null;
  }

  const query = ebayEngineSearchQuery(vehicle);
  const withoutEngineSuffix = query.replace(/\s+engine\s*$/i, "").trim();

  if (!withoutEngineSuffix) {
    return null;
  }

  return `https://www.ebay.co.uk/sch/i.html?_nkw=${encodeURIComponent(query)}&_sacat=0&_from=R40&rt=nc&LH_ItemCondition=4&LH_Sold=1&LH_Complete=1`;
}

export function ebaySearchString(searchTerm: string) {
  return `https://www.ebay.co.uk/sch/i.html?_nkw=${searchTerm}&_sacat=0&_from=R40&rt=nc&LH_ItemCondition=4&LH_Sold=1&LH_Complete=1`
}
